import { ReportAsset } from 'shared/types';

// Max number of cameras that list in the dropdown when choosing an alert camera
export const MAX_CAMERA_OPTIONS = 100;

export const ASSET_OPTIONS: { transLabelKey: string; value: ReportAsset }[] = [
  {
    transLabelKey: 'addIncidentReport.inputs.asset.options.image',
    value: 'image',
  },
  {
    transLabelKey: 'addIncidentReport.inputs.asset.options.social',
    value: 'socialEmbed',
  },
  {
    transLabelKey: 'addIncidentReport.inputs.asset.options.alertCamera',
    value: 'alertCamera',
  },
];
